import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import apiService from "../services/api";
import "../styles/Login.css";

const Login = () => {
  const [loginData, setLoginData] = useState({ username: "", password: "" });
  const [loginError, setLoginError] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoginError("");
    setLoginLoading(true);

    try {
      const result = await login(loginData.username, loginData.password);

      if (result.success) {
        navigate("/");
      } else {
        setLoginError(result.error || "Login failed");
      }
    } catch (err) {
      setLoginError("An unexpected error occurred");
    } finally {
      setLoginLoading(false);
    }
  };

  return (
    <div className='login-container'>
      <div className='login-box'>
        <div className='login-header'>
          <h1>🔐 מערכת ניהול עובדים - Koral</h1>
          <p className='subtitle'>התחבר למערכת</p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleLoginSubmit} className='login-form'>
          <div className='form-field'>
            <label htmlFor='login-username'>
              שם משתמש <span className='required'>*</span>
            </label>
            <input
              type='text'
              id='login-username'
              value={loginData.username}
              onChange={(e) =>
                setLoginData({ ...loginData, username: e.target.value })
              }
              required
              autoComplete='username'
              placeholder='הזן שם משתמש'
            />
          </div>

          <div className='form-field'>
            <label htmlFor='login-password'>
              סיסמה <span className='required'>*</span>
            </label>
            <input
              type='password'
              id='login-password'
              value={loginData.password}
              onChange={(e) =>
                setLoginData({ ...loginData, password: e.target.value })
              }
              required
              autoComplete='current-password'
              placeholder='הזן סיסמה'
            />
          </div>

          {loginError && <div className='error-message'>❌ {loginError}</div>}

          <button
            type='submit'
            className='login-button'
            disabled={loginLoading}
          >
            {loginLoading ? "מתחבר..." : "התחבר"}
          </button>
        </form>

        <div className='login-footer'>
          <p>מופעל על ידי Koral Systems</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
